(function ($) {
    $.fn.switcherTour = function () {
        var $self = $(this);
        var $tourNames = $self.find('.js-tour-name');
        var $tours = $self.find('.js-tour-item');
        var lastIndexTour = $tours.length;
        var dateNow = new Date();
        var yearNow = dateNow.getFullYear();
        var activeClass = 'active';
        var notActiveClassButtonPrev = 'prevNotActive';
        var notActiveClassButtonNext = 'nextNotActive';
        var startIndex = $self.data('start-index') || 0;

        /**
         * Инициализация первых действий
         */
        var firstAction = function () {
            initFirstItem();

            var $activeTab = $tours.eq(startIndex);
            $activeTab.each(function () {
                var $matches = $(this).find('.js-swiper-slide');
                var lastMatch = $matches.eq($matches.length - 1).find('.js-tour-date');
                var date = parseDate(lastMatch);
                if (date) {
                    var newDate = new Date(date.year, date.month, date.day);
                    if (+dateNow > +newDate) {
                        startIndex = startIndex + 1;
                        if (startIndex >= lastIndexTour) {
                            return;
                        }
                        removeActiveClass();
                        initFirstItem();
                    }
                }
            });
        };

        /**
         * Инициализация первых табов
         */
        var initFirstItem = function () {
            $tourNames.eq(startIndex).addClass(activeClass);
            $tours.eq(startIndex).addClass(activeClass);
        };

        /**
         * парсит строку даты на день месяц и год
         */
        var parseDate = function (lastMatch) {

            var date = {};
            var day = lastMatch.data('day');
            var month = lastMatch.data('month');
            var year = lastMatch.data('year');

            if (year === 'noyear') {
                year = yearNow;
            }

            if (day === 'noday' || month === 'nomonth') {
                return false;
            }
            month = Number(month) - 1;
            day = Number(day) + 3;

            date.day = day;
            date.month = month;
            date.year = year;
            return date;
        };


        /**
         * Очистка активных классов
         */
        var removeActiveClass = function () {
            $tourNames.removeClass(activeClass);
            $tours.removeClass(activeClass);
        };

        /**
         * переключение на следующий таб
         */
        var activateNextTab = function (index) {
            if(index === $tourNames.length - 1) {
                return;
            }
            removeActiveClass();
            $tourNames.eq(index + 1).addClass(activeClass);
            $tours.eq(index + 1).addClass(activeClass);
        };

        /**
         * переключение на предыдущий таб
         */
        var activatePrevTab = function (index) {
            if(index === 0) {
                return;
            }
            removeActiveClass();
            $tourNames.eq(index - 1).addClass(activeClass);
            $tours.eq(index - 1).addClass(activeClass);
        };
        /**
         * инициализация
         */
        var init = function () {
            firstAction();
            $tourNames.each(function (index) {
                var $buttonPrev = $(this).find('.js-prev');
                var $buttonNext = $(this).find('.js-next');
                $tourNames.eq(0).addClass(notActiveClassButtonPrev);
                $tourNames.eq($tourNames.length - 1).addClass(notActiveClassButtonNext);
                $buttonNext.on('click', function () {
                    activateNextTab(index);
                });
                $buttonPrev.on('click', function () {
                    activatePrevTab(index, $buttonPrev);
                });
            });
        };

        init();
    };
    $('.js-tour').each(function () {
        $(this).data('switcherTour', $(this).switcherTour());
    });
})(jQuery);
